import React from 'react';
import { Disposable } from '../../common/disposable';
import { uuidv4 } from '../../common/uuid';
/** 保存组件上的配置 */
export class ExtensionRegistry {
    constructor() {
        this.extensions = [];
        this.containerClassNames = new Set();
        this.addCoreModule = (extension) => {
            // core module 添加在前面
            this.extensions.unshift(extension);
            return Disposable.create(() => {
                this.removeExtension(extension);
            });
        };
        this.addExtension = (extension) => {
            this.extensions.push(extension);
            return Disposable.create(() => {
                this.removeExtension(extension);
            });
        };
        this.removeExtension = (extension) => {
            const idx = this.extensions.indexOf(extension);
            if (idx > -1) {
                this.extensions.splice(idx, 1);
            }
        };
        this.getInstaceId = () => {
            return this.instanceId;
        };
        this.addContainerClassNames = (clz) => {
            return this.containerClassNames.add(clz);
        };
        this.getContainerClassNames = () => {
            return Array.from(this.containerClassNames);
        };
        this.getAllExtensions = () => {
            return this.extensions;
        };
        this.getAllExtensionConfigs = () => {
            return this.extensions.map(i => i.config);
        };
        this.instanceId = uuidv4();
    }
    has(name) {
        return this.extensions.some(ext => ext.config.CONFIG_TYPE === name);
    }
}
/** 获取Xflow extension，用于收集React组件的配置 */
export const createExtensionRegistry = () => {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    const registry = React.useMemo(() => {
        return new ExtensionRegistry();
    }, []);
    return registry;
};
//# sourceMappingURL=extension-registry.js.map